import React from "react";

const DOT_COLORS = {
    completed: "bg-green-500",
    running: "bg-blue-500 animate-pulse",
    failed: "bg-red-500",
    pending: "bg-gray-300",
};

function StepProgressBar({ stepProgress, totalSteps }) {
    const dots = [];
    for (let i = 0; i < totalSteps; i++) {
        const stepExec = stepProgress[i];
        dots.push(stepExec ? stepExec.status : "pending");
    }

    return (
        <div className="flex items-center gap-0.5">
            {dots.map((status, i) => (
                <React.Fragment key={i}>
                    <div className={`h-1.5 w-1.5 rounded-full ${DOT_COLORS[status] || DOT_COLORS.pending}`} title={`Step ${i + 1}: ${status}`} />
                    {i < dots.length - 1 && <div className="h-px w-1.5 bg-gray-200" />}
                </React.Fragment>
            ))}
        </div>
    );
}

export default StepProgressBar;
